import React from 'react';
import styled from 'styled-components';
import Loading from './Loading';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    background-color: #e2e2e2;
    height: 100vh;
`;

const Title = styled.span`
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 17px;
    color: #000;
    font-weight: bold;
    margin-top: 20;
`;

const ApplicationLoading = ({ ...props }) => (
    <Container>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 80 }}>
            <Loading color="#5777FB" />
            <Title>Carregando o chat ...</Title>
        </div>
    </Container>
);

export default ApplicationLoading;


// WEBPACK FOOTER //
// ./src/components/loading/presentational/ApplicationLoading.js